import myaxios from "../utils/myaxios";

export function getPackages(data) {
    return myaxios({
        url: '/manager/package/get-packages',
        data,
        method: 'post'
    })
}

export function importPackage(data) {
    return myaxios({
        url: '/manager/package/import-package',
        params: data
    })
}

export function removePackage(data) {
    return myaxios({
        url: '/manager/package/deletePackage',
        data,
        method: 'post'
    })
}

export function addPackage(data) {
    return myaxios({
        url: '/manager/package/savePackage',
        data,
        method: 'post'
    })
}

export function loadPackage(data) {
    return myaxios({
        url: '/manager/package/load-package',
        data,
        method: 'post'
    })
}